import { onMounted, onUnmounted, ref } from 'vue';

/**
 * Reactive matchMedia helper. SSR-safe (false until client can evaluate).
 * @param {string} query e.g. '(min-width: 900px)'
 */
export function useMediaQuery(query) {
    const matches = ref(
        typeof window !== 'undefined' && typeof window.matchMedia === 'function'
            ? window.matchMedia(query).matches
            : false
    );
    let media = null;

    function update() {
        matches.value = Boolean(media?.matches);
    }

    onMounted(() => {
        if (typeof window === 'undefined' || !window.matchMedia) {
            return;
        }

        media = window.matchMedia(query);
        update();
        media.addEventListener('change', update);
    });

    onUnmounted(() => {
        media?.removeEventListener('change', update);
    });

    return matches;
}
